/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateSectionsControllerFindOneQueryResponse, TemplateSectionsControllerFindOnePathParams, TemplateSectionsControllerFindOneQueryParams, TemplateSectionsControllerFindOne400, TemplateSectionsControllerFindOne401, TemplateSectionsControllerFindOne403, TemplateSectionsControllerFindOne404 } from "../../models/checklistsController/TemplateSectionsControllerFindOne";

function getTemplateSectionsControllerFindOneUrl(id: TemplateSectionsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-template-sections/${id}` as const }  
  return res
}

/**
 * @summary Get a specific checklist template section by ID
 * {@link /api/v1/checklist-template-sections/:id}
 */
export async function templateSectionsControllerFindOne(id: TemplateSectionsControllerFindOnePathParams["id"], params?: TemplateSectionsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateSectionsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateSectionsControllerFindOne400 | TemplateSectionsControllerFindOne401 | TemplateSectionsControllerFindOne403 | TemplateSectionsControllerFindOne404>, unknown>({ method : "GET", url : getTemplateSectionsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}